// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6110":"ba966e1469444620","7839":"e6a149f727af8be1"}[chunkId] + ".js";
};